module.exports = "/_next/static/images/tamawarai_menu_top-f2546c4abda713e5d899efdd125e570f.jpg";